import { render } from "./former-employee.vue?vue&type=template&id=6dfe1c64&scoped=true&ts=true"
import script from "./former-employee.vue?vue&type=script&lang=ts"
export * from "./former-employee.vue?vue&type=script&lang=ts"

import "./former-employee.vue?vue&type=style&index=0&id=6dfe1c64&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfe1c64"]])

export default __exports__